var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-activate-success-view"},[_c('h1',[_vm._v("Cuenta activada")]),_vm._v(" "),_c('p',[_vm._v("Tu cuenta ha sido activada con éxito.")]),_vm._v(" "),_c('router-link',{staticClass:"el-button el-button--primary",attrs:{"to":{name:'login'}}},[_vm._v("\n    Ir al login\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a54a2f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/login-activate-success.view.vue
// module id = null
// module chunks = 